var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_455_2369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.31185 16.136C3.70009 16.2753 4.12354 16.0714 4.26107 15.688L6.21766 10.2333C6.40751 9.70395 7.09315 9.57006 7.46843 9.98791L7.73503 10.2847C8.82816 11.5017 10.8192 11.1644 11.4477 9.65103L13.1386 5.5802C13.3482 5.0757 14.014 4.962 14.3785 5.37154L14.883 5.93846C15.1555 6.24465 15.6246 6.272 15.9309 5.9995C16.237 5.72701 16.2644 5.25787 15.9919 4.95168L15.4874 4.38476C14.3969 3.15941 12.3982 3.49321 11.7678 5.01083L10.0769 9.08166C9.86719 9.58664 9.20508 9.70005 8.83937 9.29285L8.57277 8.99605C7.44732 7.7429 5.39001 8.14424 4.82046 9.73211L2.86387 15.1868C2.72545 15.5726 2.92602 15.9976 3.31185 16.136Z",
    fill: "#8276F4",
    stroke: "#F7F4FF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2578 17.5156H2.22656C1.81732 17.5156 1.48438 17.1827 1.48438 16.7734V0.742188C1.48438 0.332277 1.1521 0 0.742188 0C0.332277 0 0 0.332277 0 0.742188V16.7734C0 18.0012 0.998836 19 2.22656 19H18.2578C18.6677 19 19 18.6677 19 18.2578C19 17.8479 18.6677 17.5156 18.2578 17.5156Z",
    fill: "#8276F4",
    stroke: "#F7F4FF",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_455_2369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalout);
export default __webpack_public_path__ + "static/media/goalout.5ea03737bcd66c2fdc715de3c64f89e0.svg";
export { ForwardRef as ReactComponent };